import { Routes } from '@angular/router';

export const USERS_ROUTES: Routes = [
  {
    path: 'create',
    loadComponent: () =>
      import('../users/user-create-page/user-create.page').then((c) => c.UserCreatePage),
  },
  {
    path: ':userId',
    loadComponent: () =>
      import('../users/user-details-page/user-details.page').then((c) => c.UserDetailsPage),
  },
  {
    path: ':userId/edit/contact',
    loadComponent: () =>
      import('../users/user-contact-edit-page/user-contact-edit.page').then(
        (c) => c.UserEditContactPage,
      ),
  },
  {
    path: ':userId/edit/passport',
    loadComponent: () =>
      import('./user-passport-edit-page/user-passport-edit.page').then(
        (c) => c.UserEditPassportPage,
      ),
  },
  {
    path: ':userId/edit/picture',
    loadComponent: () =>
      import('../users/user-picture-edit-page/user-picture-edit.page').then(
        (c) => c.UserEditPicturePage,
      ),
  },
  {
    path: ':userId/edit/roles',
    loadComponent: () =>
      import('./user-roles-edit-page/user-roles-edit.page').then((c) => c.UserEditRolesPage),
  },
  {
    path: '',
    loadComponent: () => import('./user-list-page/user-list.page').then((c) => c.UserListPage),
  },
  { path: '**', redirectTo: '' },
];
